<template>
    <div 
        :id="nombre + '-iframe-box'" 
        class="iframe-box"
    >
        <iframe 
            :id="nombre"
            :src="URL"
            class="iframe-responsivo" 
            :name="nombre"
            scrolling="no" 
            frameborder="0" 
            @load="loadIframe"
        >
            <p>Su navegador no es compatible con iframes</p>
        </iframe>
    </div>
</template>

<script>
export default {
    components: {
    },
    props: {
        nombre: {
            type: String,
            requiered: true,
            default: "",
        },
        slug: {
            type: String,
            requiered: true,
            default: "",
        },
    },
    computed: {
        URL() {
            let root = this.$store.getters.getRootURL;
            return root + "/" + this.slug + "/"
        }
    },
    created() {     
    },
    beforeMount() {  
    },
    mounted() {
        window.addEventListener("resize", this.recizeHandler);
    },
    methods: {
        loadIframe(){
            this.recizeHandler();
            setTimeout(this.recizeHandler,1000)
        },
        recizeHandler(){
            this.resizeIFrameToFitContent()
        },
        resizeIFrameToFitContent(){
            let iframe = document.getElementById(this.nombre);
            let iframeBox = document.getElementById(this.nombre + '-iframe-box');
            if (iframe != null) {
                try {
                    console.log(iframe.contentWindow.document.body.scrollHeight )
                    iframe.height = (iframe.contentWindow.document.body.scrollHeight + 80) + "px";
                    console.log(iframe.height)
                    iframeBox.style.height = iframe.height;
                } catch (error) {
                    console.log(error)
                }
            } else {
                console.log(iframe)
            }
        } 
        //TODO lanzar esta llamada cuando la ventana cambia de tamaño
        //TODO Darle margen para evitar la barra de scroll y para que si se hace algo en el formulario
        // (que aparezcan mensajes, que crezca un text area, que se despliegue algo, no sea un problema, adaptar estética a eso)
      // }
    } 
}
</script>

<style scoped>
    .iframe-box {
        position: relative;
        overflow: hidden;
        width: 100vw;
    }
    .iframe-responsivo {
        position: absolute;
        top: -40px;
        left: 0;
        width: 100%;
        border: 0;
      /* height: 100% */
    }
</style>